const wrapper = document.querySelector(".testimonial-wrapper");
const testimonials = document.querySelectorAll(".testimonial");
const prevButton = document.getElementById("prev");
const nextButton = document.getElementById("next");

let currentIndex = 0;
const visibleTestimonials = 2; // Ensure 2 testimonials are shown at a time
const totalTestimonials = testimonials.length;

// Duplicate first two testimonials at the end for seamless looping
const firstClone1 = testimonials[0].cloneNode(true);
const firstClone2 = testimonials[1].cloneNode(true);
wrapper.appendChild(firstClone1);
wrapper.appendChild(firstClone2);

function updateButtons() {
  if (currentIndex === 0) {
    prevButton.classList.add('disabled');
    prevButton.disabled = true;
  } else {
    prevButton.classList.remove('disabled');
    prevButton.disabled = false;
  }
}

function showTestimonial(index) {
  const screenWidth = window.innerWidth;
  let translateX;

  if (screenWidth < 768) {
    translateX = 91 * index; // Mobile screens
  } else if (screenWidth >= 768 && screenWidth < 1024) {
    translateX = 95 * index; // Tablets
  } else {
    translateX = (index * 100) / (totalTestimonials + 2); // Desktop, including clones
  }

  wrapper.style.transition = "transform 0.5s ease-in-out";
  wrapper.style.transform = `translateX(-${translateX}%)`;

  if (index >= totalTestimonials) {
    setTimeout(() => {
      wrapper.style.transition = "none";
      currentIndex = 0;
      wrapper.style.transform = `translateX(0%)`;
    }, 500);
  }

  updateButtons();
}

if (totalTestimonials > 1) {
  nextButton.addEventListener("click", () => {
    if (currentIndex < totalTestimonials) {
      currentIndex++;
    } else {
      currentIndex = 0;
    }
    showTestimonial(currentIndex);
  });

  prevButton.addEventListener("click", () => {
    if (currentIndex > 0) {
      currentIndex--;
    } else {
      currentIndex = totalTestimonials - 1;
    }
    showTestimonial(currentIndex);
  });

  setInterval(() => {
    if (currentIndex < totalTestimonials) {
      currentIndex++;
    } else {
      currentIndex = 0;
    }
    showTestimonial(currentIndex);
  }, 5000);
} else {
  carouselControls.style.display = "none";
}
